import { INICIALITZAR, CANVI_TEXT_CERCA_VISTA } from "../actions/actionTypes";

const ESTAT_INICIAL = {
  textCerca: "",
  columnaCerca: ""
};

const cercaVistes = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case CANVI_TEXT_CERCA_VISTA: {
      return action.payload;
    }

    default:
      return state;
  }
};

export default cercaVistes;

export const getCercaVistes = state => state.cercaVistes;
